import { render, staticRenderFns } from "./TabBarChart.vue?vue&type=template&id=8f44d4ee&scoped=true&"
import script from "./TabBarChart.vue?vue&type=script&lang=js&"
export * from "./TabBarChart.vue?vue&type=script&lang=js&"
import style0 from "./TabBarChart.vue?vue&type=style&index=0&id=8f44d4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f44d4ee",
  null
  
)

export default component.exports